// extracted by mini-css-extract-plugin
export default {"container":"Sidemenu_container__lE+gM","menu":"Sidemenu_menu__nGi36"};